import { S1CloudProvider, S1CloudProviderData, S1Endpoint } from 'common/graphqlTypes';
import { CLOUD_PROVIDER } from './types';
import { CloudProvidersConfigurations } from './consts';

/**
 * This function decide when cloud providers tab should display.
 *
 * @prop endpoint the endpoints data.
 */
export function isCloudProvidersVisible(endpoint: S1Endpoint | undefined): boolean {
  return (
    !!endpoint?.cloudProviders &&
    endpoint.cloudProviders.filter(
      (s1CloudProvider: S1CloudProvider) =>
        CloudProvidersConfigurations[s1CloudProvider.name as CLOUD_PROVIDER]?.isSupported,
    ).length > 0
  );
}

/**
 * This function normalize fields row value into array of values.
 *
 * @prop s1CloudProvidersData the cloud provider data object.
 * @prop fieldKey the field key we want to normalize.
 *
 * @return array of fields value.
 * if there was only one value will return array with one element
 * if there was no value, will return empty array.
 */
export function getFieldValues(
  s1CloudProvidersData: S1CloudProviderData,
  fieldKey: keyof S1CloudProviderData,
): string[] {
  const rawFieldValue = s1CloudProvidersData?.[fieldKey];
  return rawFieldValue ? ((Array.isArray(rawFieldValue) ? rawFieldValue : [rawFieldValue]) as string[]) : [];
}
